import { Component, OnInit } from '@angular/core'
import { ActivatedRoute } from '@angular/router'
import { Store, select } from '@ngrx/store'
import Validator from '@shared/validatorjs/src/validator'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import FormTrait from 'src/app/traits/form.trait'
import {
  FetchIndustryRequest,
  SetDefaultData,
  UpdateField,
  UpdateIndustryRequest,
} from '../industries.actions'
import { getUpdateIndustryState } from '../industries.selectors'

@Component({
  selector: 'app-update-industry',
  templateUrl: './update-industry.component.html',
  styleUrls: ['./update-industry.component.css'],
})
export class UpdateIndustryComponent extends FormTrait implements OnInit {
  private state$: Subscription
  public isLoading: boolean
  public userId: number

  constructor(public store: Store<any>, private route: ActivatedRoute) {
    super()
  }

  ngOnInit() {
    this.userId = parseInt(this.route.snapshot.paramMap.get('id'), 10)
    this.store.dispatch<any>(new SetDefaultData('updateIndustry'))
    this.state$ = this.store
      .pipe(select(getUpdateIndustryState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.store.dispatch<any>(new FetchIndustryRequest(this.userId))
  }

  public handleFieldChange(
    e: any,
    name: null | string = null,
    row: null | number = null,
  ): void {
    if (row !== null) {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name
            ? e
            : isNaN(e.target.value)
            ? e.target.value
            : parseFloat(e.target.value),
          `updateIndustry.data.subIndustryList.${row}`,
        ),
      )
    } else {
      this.store.dispatch(
        new UpdateField(
          name || e.target.name,
          name ? e : e.target.value,
          'updateIndustry.data',
        ),
      )

      this.store.dispatch(
        new UpdateField(
          'validationErrors',
          this.state.get('validationErrors').delete(name || e.target.name),
          'updateIndustry',
        ),
      )
    }
  }

  public rowDelete(row: number) {
    const list = this.state.getIn(['data', 'subIndustryList']) as any

    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.delete(row).toJS(),
        `updateIndustry.data`,
      ),
    )
  }

  public rowAdd() {
    const list = this.state.getIn(['data', 'subIndustryList']) as any

    this.store.dispatch(
      new UpdateField(
        'subIndustryList',
        list.push({ name: '' }).toJS(),
        `updateIndustry.data`,
      ),
    )
  }

  private validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state.get('data').toJS()

    if (validation.passes()) {
      this.store.dispatch(new UpdateIndustryRequest(this.userId, payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'updateIndustry',
        ),
      )
    }
  }
}
